import { useEffect, useMemo } from 'react'
import render from '../renderer'
import { passDownActions as actions } from '../actions'
import { ModalProvider } from '@panwds/react-ui'

import type { VFC } from 'react'
import type { CommonStoreState } from '../store'


const ActivationPage: VFC<{ state: CommonStoreState }> = ({ state }) => {
  const comp = useMemo(() => {
    if (state.screen) {
      return render(state.screen, { state, actions })
    }
    return <>No Screen!</>
  }, [state])

  useEffect(() => {
    const appClassList = document.querySelector('.sparky-app')?.classList
    appClassList?.add('sparky-app-bar-z-0')
    return () => {
      appClassList?.remove('sparky-app-bar-z-0')
    }
  }, [])

  return (
    <ModalProvider>
      <div data-testid='sparky-activation-page' className='sparky-activation-page cm-py-10 cm-overflow-y-auto cm-overflow-x-hidden cm-fixed cm-top-0 cm-left-0 cm-right-0 cm-bottom-0 tw-bg-white dark:tw-bg-gray-1050'>
        {comp}
      </div>
    </ModalProvider>
  )
}

export default ActivationPage
